import { apiRequest } from './client'

export type NotificationCategory = 'studio' | 'task' | 'account' | 'system'

export interface UserNotification {
  public_id: string
  category: NotificationCategory
  event_type: string
  title: string
  body: string
  link_path: string
  source_type?: string
  source_id?: string
  actor_user_id?: number
  read: boolean
  read_at?: string
  created_at: string
}

export interface UserNotificationList {
  items: UserNotification[]
  total: number
  limit: number
  offset: number
}

export const notificationsApi = {
  list: (params?: {
    category?: NotificationCategory | ''
    unread_only?: boolean
    limit?: number
    offset?: number
  }) => apiRequest<UserNotificationList>('/api/v1/me/notifications', { query: params }),

  unreadCount: () => apiRequest<{ count: number }>('/api/v1/me/notifications/unread-count'),

  markRead: (id: string, read = true) =>
    apiRequest<UserNotification>(`/api/v1/me/notifications/${id}`, {
      method: 'PATCH',
      body: { read },
    }),

  markAllRead: (category?: NotificationCategory) =>
    apiRequest<{ ok: boolean }>('/api/v1/me/notifications/read-all', {
      method: 'POST',
      body: category ? { category } : {},
    }),
}
